import { useEffect, useMemo, useState } from 'react'
import Page from 'src/features/transfers/components/TransferReceive/Page/Page'
import UserIdentifier from 'src/features/transfers/components/TransferReceive/UserIdentifier/UserIdentifier'
import { useSelector } from 'src/utils/store'
import ConfirmAddressAndBarcode from 'src/features/transfers/components/TransferReceive/ConfirmAddressAndBarcode/ConfirmAddressAndBarcode'
import ReceiveItemMovement from 'src/features/transfers/components/TransferReceive/ReceiveItemMovement/ReceiveItemMovement'
import ReceiveItemCount from 'src/features/transfers/components/TransferReceive/ReceiveItemCount/ReceiveItemCount'

export enum ReceiveItemPageModes {
  CONFIRM_ADDRESS_AND_BARCODE = 1,
  ITEM_COUNT = 2,
  ITEM_MOVEMENT = 3,
}

const ReceiveItem = () => {
  const { receiveData, receiveUser } = useSelector((state) => state.transfers)

  const currentItem = useMemo(() => receiveData?.currentItem, [receiveData])

  const [pageMode, setPageMode] = useState(ReceiveItemPageModes.CONFIRM_ADDRESS_AND_BARCODE)

  const [startedAt, setStartedAt] = useState<Date | null>(null)

  useEffect(() => {
    setPageMode(ReceiveItemPageModes.CONFIRM_ADDRESS_AND_BARCODE)
  }, [currentItem, currentItem?.bestPosition])

  return (
    <Page headerTitle='Receber Transferência'>
      <UserIdentifier />
      {(receiveData && currentItem) && (
        <>
          {pageMode === ReceiveItemPageModes.CONFIRM_ADDRESS_AND_BARCODE && (
            <ConfirmAddressAndBarcode
              badge={receiveUser?.badge || ''}
              idCage={receiveData.idCage}
              cageAddress={receiveData.cageAddress}
              item={currentItem}
              setStartedAt={setStartedAt}
              setPageMode={setPageMode}
            />
          )}
          {pageMode === ReceiveItemPageModes.ITEM_COUNT && (
            <ReceiveItemCount
              idCage={receiveData.idCage}
              item={currentItem}
              items={receiveData.items}
              setPageMode={setPageMode}
            />
          )}
          {pageMode === ReceiveItemPageModes.ITEM_MOVEMENT && (
            <ReceiveItemMovement
              badge={receiveUser?.badge || ''}
              idCage={receiveData.idCage}
              item={currentItem}
              startedAt={startedAt!}
            />
          )}
        </>
      )}
    </Page>
  )
}

export default ReceiveItem
